import { Placeholder } from 'rsuite';
import { Dialog } from '@aleph/shared-components';
import { TwoFactorStepType } from 'wb-reddit/app/common/components/twoFactor/twoFactorModal';
import TwoFactorHeader from 'wb-reddit/app/common/components/twoFactor/twoFactorModalHeader';

interface IProps {
	type: TwoFactorStepType
	onClose: () => void
}

export default function TwoFactorCodeSkeleton({ type, onClose }: IProps) {
	return (
		<>
			<TwoFactorHeader
				type={type}
				onClose={onClose}
			/>
			<Dialog.Content>
				<div className="flex flex-col gap-3">
					<Placeholder.Graph
						height={16}
						width={240}
					/>
					<Placeholder.Graph
						height={8}
					/>
					<Placeholder.Graph
						height={8}
					/>
					<Placeholder.Graph
						height={8}
					/>
					<Placeholder.Graph
						height={184}
						width={552}
					/>
				</div>
			</Dialog.Content>
			<Dialog.Footer className='flex-row justify-center gap-6'>
				<Placeholder.Graph
					height={32}
					width={96}
				/>
				<Placeholder.Graph
					height={32}
					width={96}
				/>
			</Dialog.Footer>
		</>
	);
}
